import { combineReducers } from 'redux-immutable'
import { createMigrate, persistCombineReducers } from 'redux-persist'
import storage from 'localforage'
import immutableTransform from 'redux-persist-transform-immutable'
import { connectRouter } from 'connected-react-router/immutable'

import analytics from './entities/analytics/reducer'
import { reducer as toastr } from './entities/toastr'
import { reducer as organizations } from './entities/organizations'
import { reducer as protracks } from './entities/protracks'
import { Identity, reducer as identity } from './entities/identity'
import { reducer as ui } from './entities/ui'
import { reducer as form } from './entities/form'
import { reducer as activities } from './entities/protracks/activities'
import { reducer as orgValues } from './entities/orgValues'
import { reducer as activity } from './entities/activity'
import { reducer as feed } from './entities/feed'
import { reducer as loadingBar } from './entities/loadingBar'
import { reducer as adminWelcomeEmail } from './entities/adminWelcomeEmail'
import { reducer as adminMSTeamsWelcome } from './entities/adminMSTeamsWelcome'
import { reducer as organizationSettings } from './entities/organizationSettings'
import { reducer as gallery } from './entities/gallery'
import { reducer as orgHolidays } from './entities/orgHolidays'
import { reducer as orgInactiveNotifications } from './entities/orgInactiveNotifications'
import { Onboarding, reducer as onboarding } from './entities/onBoarding'
import { CompanyStats, reducer as companyStats } from './entities/companyStats'
import { reducer as differentActivities } from './entities/differentActivities'
import { reducer as notifications } from './entities/notifications'
import { reducer as stories } from './entities/stories'
import { reducer as users } from './entities/users'
import { reducer as reviews } from './entities/reviews'
import { reducer as tour } from './entities/tour'
import modal from './entities/modal/reducer'
import offline, { Offline } from './entities/offline/reducer'
import completedProtracks from './entities/completedProtracks/reducer'
import localSettings from './entities/localSettings/reducer'
import LocalSettings from './entities/localSettings/LocalSettings'
import { Activity } from './records/activity'
import orgLabels from './entities/orgLabels/reducer'
import globalValues from './entities/globalValues/reducer'
import videos from './entities/videos/reducer'
import generator, { Generator } from './entities/generator/reducer'
import reviewsSurveys from './entities/reviewsSurveys/reducer'

export const persistConfig = {
  version: 1,
  transforms: [
    immutableTransform({ records: [Activity, Identity, Onboarding, Offline, LocalSettings, Generator, CompanyStats] }),
  ],
  key: 'proHabits',
  storage,
  debug: true,
  whitelist: [
    '_persist',
    'activity',
    'identity',
    'offline',
    'onboarding',
    'protracks',
    'organizations',
    'localSettings',
    'generator',
    'reviewsSurveys',
    'companyStats',
  ],
  migrate: createMigrate(
    {
      1: state => {
        // Flush all the data from the redux-store except token before rehydrate if version redux-store is updated
        return {
          identity: new Identity().set('authToken', state.identity.get('authToken')),
        }
      },
    },
    { debug: process.env.NODE_ENV === 'development' }
  ),
}

const rootReducer = history =>
  combineReducers({
    activities,
    analytics,
    feed,
    form,
    orgValues,
    ui,
    router: connectRouter(history),
    toastr,
    loadingBar,
    adminWelcomeEmail,
    adminMSTeamsWelcome,
    organizationSettings,
    orgHolidays,
    gallery,
    orgInactiveNotifications,
    differentActivities,
    companyStats,
    modal,
    completedProtracks,
    orgLabels,
    globalValues,
    videos,
    notifications,
    stories,
    tour,
    // persist works only when the rootReducer is a plain object. extra libraries was not working at 1 May 2018
    persist: persistCombineReducers(persistConfig, {
      activity,
      identity,
      offline,
      onboarding,
      organizations,
      protracks,
      localSettings,
      users,
      reviews,
      generator,
      reviewsSurveys,
      companyStats,
    }),
  })

export default rootReducer
